// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3GnxW","header":"ReportDetails_header__vD3_w","title":"ReportDetails_title__1yVZk","left":"ReportDetails_left__3CuJI"};